import React, {FC, useState} from "react";
import LayoutPage from "components/LayoutPage/LayoutPage";
import Input from "components/Input/Input";
import ButtonPrimary from "components/Button/ButtonPrimary";
import NcLink from "components/NcLink/NcLink";
import {Helmet} from "react-helmet";
import {auth} from "../../configs/firebase-config";
import {fetchSignInMethodsForEmail, sendPasswordResetEmail} from "firebase/auth";
import {useHistory} from "react-router";
import {displayToast, toastType} from "../../global/Functions";

export interface PageForgotPassProps {
    className?: string;
}

const PageForgotPass: FC<PageForgotPassProps> = ({className = ""}) => {
  let history = useHistory();
  const [email, setEmail] = useState("");

  // TODO: Ali to design and implement error checks in the following function
  const handleResetEmail = (e: any) => {
    e.preventDefault();
    fetchSignInMethodsForEmail(auth, email).then(async (methods) => {
      if (methods.length >= 1) {
        if (methods[0] === "password") {
          try {
            await sendPasswordResetEmail(auth, email);
            displayToast("Email sent to reset password", toastType.info);
          } catch (error) {
            displayToast("Something went wrong!", toastType.error);
          }
        } else {
          displayToast("App registered with " + String([methods[0].split(".")[0]]), toastType.warn);
        }
        e.target.reset();
        history.replace("/login");
      } else {
        displayToast("Email not registered", toastType.error);
      }
    })
  }

  return (
    <div
      className={`PageForgotPass ${className}`}
      data-nc-id="PageForgotPass"
    >
      <Helmet>
        <title>Forgot Password | CryptoVerse</title>
      </Helmet>
        <LayoutPage
          subHeading="We will send reset password instructions to the email provided"
          headingEmoji="🔒"
          heading="Forgot password"
        >
          <div className="max-w-md mx-auto space-y-6">
            <form className="grid grid-cols-1 gap-6" action="#" method="post" onSubmit={handleResetEmail}>
              <label className="block">
                <span className="text-neutral-800 dark:text-neutral-200">
                  Email address
                </span>
                <Input
                  type="email"
                  placeholder="name@example.com"
                  className="mt-1"
                  required
                  onChange={(e) => setEmail(e.target.value)}
                />
              </label>
              <ButtonPrimary type="submit">Continue</ButtonPrimary>
            </form>
            <span className="block text-center text-neutral-700 dark:text-neutral-300">
              Go back for {` `}
              <NcLink to="/login">Sign in</NcLink>
              {` / `}
              <NcLink to="/signup">Sign up</NcLink>
            </span>
          </div>
        </LayoutPage>
    </div>
  );
};

export default PageForgotPass;
